import React from 'react'
import { ItensAusentes } from './ausentes'

interface Props {
  ausentes: ItensAusentes
  /** Onde cada item é usado na versão aberta (nome do item → lugares). Sem isso, só lista os itens. */
  usos?: Record<string, string[]>
  aoVerDicionario?: () => void
}

/**
 * O dicionário libera algo que o modelo do Power BI não tem mais (renomeado ou removido lá). É o motivo de blocos darem erro
 * ("O modelo não respondeu"), e sem este aviso só aparece quem testa a consulta bloco a bloco.
 */
export default function AvisoAusentes({ ausentes, usos, aoVerDicionario }: Props) {
  const itens = [
    ...ausentes.colunas.map(nome => ({ nome, tipo: 'coluna' })),
    ...ausentes.medidas.map(nome => ({ nome, tipo: 'medida' }))
  ]
  if (itens.length === 0) return null

  return (
    <div className="rh-alerta erro" role="alert" data-testid="aviso-ausentes">
      <b>O modelo não tem mais {itens.length === 1 ? '1 item' : `${itens.length} itens`} que este relatório libera.</b>
      <ul>
        {itens.map(i => {
          const onde = usos?.[i.nome]
          return (
            <li key={`${i.tipo}-${i.nome}`}>
              <code>{i.nome}</code> ({i.tipo})
              {usos && (onde?.length ? <> · usado em {onde.join(', ')}</> : <> · não é usado nesta versão</>)}
            </li>
          )
        })}
      </ul>
      <p style={{ margin: '6px 0 0' }}>
        Os blocos que usam esses itens dão erro. Escolha outro item no bloco (aba Dados) ou peça ao time do modelo para devolvê-lo,
        e depois tire o item do dicionário.
      </p>
      {aoVerDicionario && (
        <div style={{ marginTop: 8 }}>
          <button type="button" className="ng-btn" onClick={aoVerDicionario}>Ver no dicionário</button>
        </div>
      )}
    </div>
  )
}
